import React from "react";

import styles from "./ReportCellLayoutManagerDropdown.module.scss";
import { IoClose } from "react-icons/io5";
import { useReportBespoke } from "@iliotech/data-wire";
import {
  BottomLeft,
  BottomRight,
  Center,
  CenterLeft,
  CenterRight,
  TopLeft,
  CenterTop,
} from "./assets";
import {
  AlignmentType,
  TemplateType,
} from "@iliotech/data-wire/src/stores/ReportBespoke/ReportBespokeStore";
import { TopRight } from "./assets/TopRight";
import { CenterBottom } from "./assets/CenterBottom";

interface Props {
  onClose: () => void;
  pageId: string;
  cellId: string;
}
const LAYOUT_ITEMS_ROW_ONE = [{ icon: Center, id: AlignmentType.CENTER }];
const LAYOUT_ITEMS_ROW_TWO = [
  { icon: CenterLeft, id: AlignmentType.CENTER_LEFT },
  { icon: CenterRight, id: AlignmentType.CENTER_RIGHT },
  { icon: CenterBottom, id: AlignmentType.CENTER_BOTTOM },
  { icon: CenterTop, id: AlignmentType.CENTER_TOP },
];

const LAYOUT_ITEMS_ROW_THREE = [
  { icon: TopLeft, id: AlignmentType.TOP_LEFT },
  { icon: TopRight, id: AlignmentType.TOP_RIGHT },
  { icon: BottomLeft, id: AlignmentType.BOTTOM_LEFT },
  { icon: BottomRight, id: AlignmentType.BOTTOM_RIGHT },
];

export const LayoutRows = [
  LAYOUT_ITEMS_ROW_ONE,
  LAYOUT_ITEMS_ROW_TWO,
  LAYOUT_ITEMS_ROW_THREE,
];
export const ReportCellLayoutManagerDropdown: React.FC<Props> = ({
  onClose,
  pageId,
  cellId,
}) => {
  const store = useReportBespoke();
  return (
    <div className={styles.dropdown}>
      <div className={styles.header}>
        <span>Choose alignment</span>
        <IoClose className={styles.close} onClick={onClose} />
      </div>
      <div className={styles.layoutOptions}>
        {LayoutRows.map((row, index) => (
          <div key={index} className={styles.layoutOptionsRow}>
            {row.map((item) => (
              <div
                key={item.id}
                className={styles.layoutOption}
                onClick={() =>
                  store.updateCellAlignment(pageId, cellId, item.id)
                }
              >
                {item.icon()}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
